"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsBatchTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsExport = require("../DmsExport/DmsExport");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsBatchStatusRectangle = require("./DmsBatchStatusRectangle");
var _BatchStatus = require("../../constants/BatchStatus");
var _moment = _interopRequireDefault(require("moment"));
var _DateTimeFormats = require("../../constants/DateTimeFormats");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsBatchTable.
 * Renders a DmsTable with batch datas
 * @component
 * @example
 * return (
 *   <DmsBatchTable />
 * )
 */

const DmsBatchTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Number").d("Number"),
    column_name: "number",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Quantity").d("Quantity"),
    column_name: "quantity",
    filter: true,
    sortable: true
  }, {
    label: _reactIntlUniversal.default.get("Fabrication").d("Fabrication"),
    column_name: "fabrication",
    filter: true,
    sortable: true,
    function: date => (0, _moment.default)(date).format(_DateTimeFormats.DATE_TIME_FORMATS.DAY_MONTH_YEAR_HOUR_MINUTE),
    control: 'datetime',
    disableManualInput: true
  }, {
    label: _reactIntlUniversal.default.get("Expiration").d("Expiration"),
    column_name: "expiration",
    filter: true,
    sortable: true,
    function: date => (0, _moment.default)(date).format(_DateTimeFormats.DATE_TIME_FORMATS.DAY_MONTH_YEAR_HOUR_MINUTE),
    control: 'datetime',
    disableManualInput: true
  }, {
    label: _reactIntlUniversal.default.get("Part").d("Part"),
    column_name: "part",
    form_column_name: "part_pk",
    control: 'select',
    url: "/part/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: "name",
      filter: {
        value: "pk",
        field: "part_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Status").d("Status"),
    column_name: "status",
    map: {
      [_BatchStatus.BatchStatus.CREATED]: /*#__PURE__*/_react.default.createElement(_DmsBatchStatusRectangle.DmsBatchStatusRectangle, {
        status: _BatchStatus.BatchStatus.CREATED
      }),
      [_BatchStatus.BatchStatus.STARTED]: /*#__PURE__*/_react.default.createElement(_DmsBatchStatusRectangle.DmsBatchStatusRectangle, {
        status: _BatchStatus.BatchStatus.STARTED
      }),
      [_BatchStatus.BatchStatus.PAUSED]: /*#__PURE__*/_react.default.createElement(_DmsBatchStatusRectangle.DmsBatchStatusRectangle, {
        status: _BatchStatus.BatchStatus.PAUSED
      }),
      [_BatchStatus.BatchStatus.FINISHED_OK]: /*#__PURE__*/_react.default.createElement(_DmsBatchStatusRectangle.DmsBatchStatusRectangle, {
        status: _BatchStatus.BatchStatus.FINISHED_OK
      }),
      [_BatchStatus.BatchStatus.FINISHED_NOK]: /*#__PURE__*/_react.default.createElement(_DmsBatchStatusRectangle.DmsBatchStatusRectangle, {
        status: _BatchStatus.BatchStatus.FINISHED_NOK
      })
    },
    control: 'select',
    filter: true,
    sortable: false,
    can_create: false,
    can_edit: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "80px",
    sortable: false,
    element: row => {
      const number = row.number;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateBatch", {
          number
        }).d("Update batch {number}"),
        url: "/batch",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteBatch", {
          number
        }).d("Delete batch {number}"),
        text: _reactIntlUniversal.default.get("Batch.DeleteMensage", {
          number
        }).d("Delete batch with number {number}. Are you sure about it?"),
        url: "/batch",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateBatch").d("Create batch"),
    url: "/batch",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "batch/table",
    responsive: true,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsBatchTable = DmsBatchTable;